import React, { useState, useEffect } from "react";
import "./css/styles.css";
import { DataGrid } from "@mui/x-data-grid";
import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  Box,
  Modal,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";

import { muiAbtn, muiBbtn } from "./style";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import CreativeImage from "./CreativeImage";
import {
  collection,
  getDocs,
  setDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  deleteDoc,
  onSnapshot,
} from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db, storage } from "../firebase";
import { useNavigate } from "react-router-dom";
import {
  getDownloadURL,
  uploadBytesResumable,
  ref,
  uploadBytes,
} from "firebase/storage";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "#fff",
  boxShadow: 24,
  p: 4,
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
};

export default function News() {
  const [rows, setRows] = useState([]);
  const [isupdate, setisupdate] = useState(false);
  const [loading, setLoading] = useState(false); ///To check if data if loaded or not from collection.
  const [isProcessing, setisProcessing] = useState(false);
  const [open, setOpen] = useState(false);
  const [newsContent, setnewsContent] = useState("");
  const [newsDescription, setnewsDescription] = useState("");
  const [DocId, setDocId] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [imagePrev, setImagePrev] = useState("");
  const [UploadImage, setUploadImage] = useState(null);
  const [categories, setCategories] = useState([]);
  const [Category, setCategory] = useState([]);

  const navigate = useNavigate();
  useEffect(() => {
    let active = true;
    const getData = async () => {
      onSnapshot(
        query(collection(db, "news"), orderBy("created_at", "desc")),
        (data) => {
          setRows([]);
          setLoading(true);

          data.docs.map((docs) => {
            const contact = docs.data();

            const rowData = { ...contact, id: docs.id };
            setRows((rows) => [...rows, rowData]);
          });

          setLoading(false);
        }
      );
      const catdata = await getDocs(
        query(collection(db, "category"), orderBy("name", "asc"))
      );
      setCategories([]);
      //////Mapping Through App Documents And Then Saving them in Categories use
      catdata.docs.map((document) => {
        setCategories((row) => [
          ...row,
          {
            ...document.data(),
          },
        ]);
      });
      if (!active) {
        return;
      }

      setLoading(false);
      return () => {
        active = false;
      };
    };
    getData();
  }, []);

  const handleOpen = () => {
    setOpen(true);
    setnewsContent("");
    setnewsDescription("");
  };
  const handleOpenUpdate = (
    newsContent = "",
    id = "",
    category = [],
    newsDescription = "",
    imageUrl = ""
  ) => {
    setImagePrev(imageUrl);
    setisupdate(true);
    setnewsContent(newsContent);
    setCategory(category);
    setnewsDescription(newsDescription);
    setDocId(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setUploadImage(null);
    setnewsContent("");
    setnewsDescription("");
    setImagePrev("");
    setCategory([]);

    setisupdate(false);
    setisProcessing(false);
  };

  const handleClickOpen = (id) => {
    setOpenDialog(true);
    setDocId(id);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDocId("");
    setisProcessing(false);
  };

  const deletenews = () => {
    setisProcessing(true);
    deleteDoc(doc(db, "news", DocId))
      .then(() => {
        toast.info("news Deleted");
        handleCloseDialog();
      })
      .catch((error) => {
        handleCloseDialog();
        toast.error("Error! Unable to Delete news");
        console.log(error);
      });
  };

  const addnews = () => {
    if (!newsContent) {
      toast.error("News Cant be Empty");
      return;
    }
    setisProcessing(true);

    if (isupdate) {
      if (UploadImage) {
        const storageRef = ref(
          storage,
          `/News/news_image${new Date().getTime() / 1000}`
        );

        const uploadTask = uploadBytesResumable(storageRef, UploadImage);

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const percent = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
          },
          (err) => console.log(err),
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then((url) => {
              updateDoc(doc(db, "news", DocId), {
                newsContent: newsContent,
                newsDescription: newsDescription,
                category: Category,
                imageUrl: url,
              })
                .then(() => {
                  handleClose();
                  toast.success("news Updated");
                })
                .catch((error) => {
                  handleClose();
                  toast.error("Error! unable to Update news");
                  console.log(error);
                });
            });
          }
        );
      } else {
        updateDoc(doc(db, "news", DocId), {
          newsContent: newsContent,
          newsDescription: newsDescription,
          category: Category,
        })
          .then(() => {
            handleClose();
            toast.success("news Updated");
          })
          .catch((error) => {
            handleClose();
            toast.error("Error! unable to Update news");
            console.log(error);
          });
      }
    } else {
      if (UploadImage) {
        const storageRef = ref(
          storage,
          `/News/news_image${new Date().getTime() / 1000}`
        );

        const uploadTask = uploadBytesResumable(storageRef, UploadImage);

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const percent = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
          },
          (err) => console.log(err),
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then((url) => {
              const newDoc = doc(collection(db, "news"));
              const doc_id = newDoc.id;
              setDoc(newDoc, {
                newsContent: newsContent,
                newsDescription: newsDescription,
                id: doc_id,
                source: "Admin",
                created_at: new Date(),
                category: Category,
                imageUrl: url,
              })
                .then(() => {
                  handleClose();
                  toast.success("news Added");
                })
                .catch((error) => {
                  handleClose();
                  toast.error("Error! unable to Add news");
                  console.log(error);
                });
            });
          }
        );
      } else {
        const newDoc = doc(collection(db, "news"));
        const doc_id = newDoc.id;
        setDoc(newDoc, {
          newsContent: newsContent,
          newsDescription: newsDescription,
          id: doc_id,
          source: "Admin",
          created_at: new Date(),
          entryDate:"",
          category: Category,
          imageUrl: "",
        })
          .then(() => {
            handleClose();
            toast.success("news Added");
          })
          .catch((error) => {
            handleClose();
            toast.error("Error! unable to Add news");
            console.log(error);
          });
      }
    }
  };
  const formatTimestamp = (timestamp) => {
    const date = timestamp.toDate(); // Convert Firebase Timestamp to JavaScript Date
    const dateString = `${
      date.getMonth() + 1
    }/${date.getDate()}/${date.getFullYear()}`;
    const timeString = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    const meridiem = date.getHours() >= 12 ? "PM" : "AM";
    return `${dateString} ${timeString} ${meridiem}`;
  };

  const columns = [
    // { field: "id", headernewsContent: "ID", width: "60" },
    {
      field: "Profile",
      headerName: "",
      width: "80",
      align: "left",
      renderCell: profileCell,
    },
    {
      field: "newsContent",
      headerName: "News Content",
      width: "350",
      align: "left",
    },
    {
      field: "source",
      headerName: "News Source",
      width: "150",
      align: "left",
    },
    {
      field: "category",
      headerName: "Category",
      width: "300",
      align: "left",
      renderCell: (params) => {
        return params.value.length > 0
          ? params.value.join(", ")
          : "All Categories";
      },
    },

    {
      field: "created_at",
      headerName: "Posted On",
      width: "180",
      align: "left",
      valueGetter: (params) => formatTimestamp(params.value),
    },

    {
      field: "Action",
      width: "300",
      align: "right",

      editable: false,
      renderCell: ActionButton,
    },
  ];
  function profileCell(params) {
    return (
      <>
        <img
          className="rounded-4"
          src={params.row.imageUrl}
          width="50px"
          height="40px"
        />
      </>
    );
  }
  function ActionButton(params) {
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          style={muiAbtn}
          size="small"
          // startIcon={<CheckCircleIcon />}
          onClick={() => {
            handleOpenUpdate(
              params.row.newsContent,
              params.row.id,
              params.row.category,

              params.row.newsDescription,
              params.row.imageUrl
            );
          }}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={muiAbtn}
          onClick={() => handleClickOpen(params.row.id)}
          // startIcon={<CancelIcon />}
        >
          Delete
        </Button>
      </>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        paddingRight: 20,
        backgroundColor: "#212C62",
      }}
    >
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure to Delete the news?"}
        </DialogTitle>

        {isProcessing ? (
          <LinearProgress />
        ) : (
          <DialogActions>
            <Button onClick={() => deletenews()}>Yes</Button>
            <Button onClick={handleCloseDialog} autoFocus>
              No
            </Button>
          </DialogActions>
        )}
      </Dialog>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form>
            <Box style={{ display: "flex", justifyContent: "end" }}>
              <CloseIcon
                onClick={handleClose}
                style={{ cursor: "pointer", color: "gray" }}
              />
            </Box>
            <h2 className="mb-4" style={{ color: "#212C62" }} mb={3}>
              {!isupdate ? "Add New news" : "Update news"}
            </h2>

            <FormControl fullWidth size="small">
              <TextField
                className="mb-4"
                id="outlined-basic"
                label="Enter News"
                variant="outlined"
                size="small"
                fullWidth
                value={newsContent}
                onChange={(e) => setnewsContent(e.target.value)}
              />
            </FormControl>
            <div className="mb-4">
              <label className="form-label col-12" htmlFor="uploadProfile">
                <b>News Image</b>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control col-12"
                  id="uploadProfile"
                  onChange={(e) => setUploadImage(e.target.files[0])}
                />
              </label>
              {imagePrev ? <img width="200px" src={imagePrev} /> : ""}
            </div>
            <FormControl fullWidth className="mb-4" size="small">
              <InputLabel id="demo-simple-select-label">
                Select Category
              </InputLabel>

              <Select
                labelId="demo-simple-select-label"
                value={Category}
                id="product_category"
                multiple
                label="Status"
                onChange={(e) => setCategory(e.target.value)}
              >
                {categories?.map((cat) => {
                  return <MenuItem value={cat.name}>{cat.name}</MenuItem>;
                })}
              </Select>
              <small className="text-danger mb-2">
                Leave the category empty to display the news in all categories.
              </small>
            </FormControl>
            <FormControl fullWidth size="small">
              <TextField
                className="mb-4"
                id="outlined-basic"
                label="Enter Description"
                variant="outlined"
                multiline
                rows={4}
                size="small"
                fullWidth
                value={newsDescription}
                onChange={(e) => setnewsDescription(e.target.value)}
              />
            </FormControl>
            <Button
              fullWidth
              className="mt-2 muibtn"
              variant="contained"
              color="primary"
              size="small"
              style={muiBbtn}
              disabled={isProcessing}
              onClick={() => addnews()}
            >
              {isProcessing ? (
                <CircularProgress sx={{ color: "white" }} size={27} />
              ) : (
                <>
                  <AddIcon style={{ marginRight: 10 }} />
                  {!isupdate ? "Add news" : "Update news"}
                </>
              )}
            </Button>
          </form>
        </Box>
      </Modal>

      <Card style={{ padding: 50, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-6">
            <h1
              className="mb-4 py-4"
              style={{ textAlign: "left", color: "#212C62" }}
            >
              <b>All News</b>
            </h1>
            <Button
              variant="contained"
              color="primary"
              style={muiBbtn}
              size="small"
              // startIcon={<CheckCircleIcon />}
              onClick={() => handleOpen()}
            >
              Add New news
            </Button>
          </div>
          <div
            className="col-6 d-flex justify-content-end"
            style={{ marginTop: "-30px" }}
          >
            <CreativeImage />
          </div>
        </div>
        <div className="mt-2">
          <h5 style={{ color: "212C62" }}>
            <b>All News</b>
          </h5>
          <DataGrid
            style={{ height: "65vh", width: "100%" }}
            columns={columns}
            rows={rows}
            // getRowId={(Rows) => Rows._id}
            pageSize={12}
            rowsPerPageOptions={[12]}
            loading={loading}
            disableColumnMenu={true}
            headerHeight={0}
            getRowSpacing={(params) => ({
              top: params.isFirstVisible ? 10 : 8,
              bottom: params.isLastVisible ? 0 : 8,
            })}
            disableSelectionOnClick
          />
        </div>
      </Card>
    </div>
  );
}
